import { useState, useEffect } from 'react'
import { sendFeedback } from 'wordpress/actions'
import { pendingFeedbackSelector } from 'wordpress/selectors'
import { ContactForm, PersonalDetails, Address, Message } from '@components/ContactForm'
import Button from '@components/Button'

import '../styles/contact-form.scss'

const Confirmation = ({ onReset }) => (
    <div className="container-fluid p-0 form-confirmation">
        <div className="container">
            <div className="row">
                <div className="col text-center">
                    <h2>
                        <T>feedback.success.title</T>
                    </h2>
                    <h3>
                        <T>feedback.success.message</T>
                    </h3>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <Link to="/" className="btn btn-outline-primary">
                        <T>feedback.btn.home</T>
                    </Link>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 text-left">
                    <button className="btn btn-primary" onClick={onReset}>
                        <T>feedback.btn.new</T>
                    </button>
                </div>
            </div>
        </div>
    </div>
)

const Contact = ({ pending, error, sendFeedback, translate, contactPurposes, buttonLabel, optionalText }) => {
    const [sent, setSent] = useState(false)

    useEffect(() => {
        if (pending && !error && !sent) {
            setSent(true)
        } else if (pending && error) {
            setSent(false)
        }
    }, [pending, error])

    const submitForm = data => {
        const labels = {}
        Object.keys(data).forEach(key => {
            labels[key] = translate(`feedback.${key}.label`)
        })

        if (!pending) sendFeedback({ ...data, labels })
    }

    return sent && !pending && !error ? (
        <Confirmation onReset={() => setSent(false)} />
    ) : (
        <ContactForm onSubmit={submitForm} error={error}>
            <PersonalDetails />
            <Address />
            <Message categories={contactPurposes} optionalText={optionalText} />
            <Button btnStyle="primary" type="submit" isLoading={pending === true}>
                {buttonLabel}
            </Button>
        </ContactForm>
    )
}

export default compose(withTranslate, connect(pendingFeedbackSelector, { sendFeedback }))(Contact)
